<div class="payments-legal">
  <a class="payments-legal-back" routerLink="/pagamenti">← Torna ai pagamenti</a>

  <header class="payments-legal-head">
    <h1>Cookie Policy — Pagamenti online</h1>
    <p class="payments-legal-updated">Ultimo aggiornamento: ottobre 2026</p>
  </header>

  <section class="payments-legal-panel">
    <h2>1. Premessa</h2>
    <p>
      Questa Cookie Policy riguarda la sezione pagamenti online
      (quota associativa, lampade votive, donazione libera). Per la Cookie
      Policy del resto del sito si veda la
      <a routerLink="/cookie">Cookie Policy generale</a>. Per i dati personali
      trattati nei pagamenti si rinvia all’
      <a routerLink="/pagamenti/privacy">informativa privacy dedicata</a>.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>2. Cookie e memorizzazioni utilizzate</h2>
    <p>
      Nella sezione pagamenti sono utilizzati strumenti tecnici necessari al
      funzionamento del servizio e, ove applicabile, all’esecuzione del
      pagamento. Non sono utilizzati cookie di profilazione o marketing.
    </p>
    <ul>
      <li>
        memorizzazione della presa visione del banner informativo sui cookie,
        per non ripresentarlo a ogni visita;
      </li>
      <li>
        eventuali cookie o memorizzazioni tecniche del sistema di pagamento
        <strong>Numia</strong>, necessari a garantire sicurezza e
        completamento dell’operazione di pagamento;
      </li>
      <li>
        eventuali cookie tecnici generati dal browser o dall’infrastruttura
        di erogazione della pagina.
      </li>
    </ul>
  </section>

  <section class="payments-legal-panel">
    <h2>3. Gestione delle preferenze</h2>
    <p>
      L’utente può gestire cookie e dati locali dalle impostazioni del
      browser. La disabilitazione di cookie tecnici può impedire il corretto
      svolgimento del pagamento.
    </p>
    <p>
      Il banner informativo consente di prendere visione di questa policy e di
      chiudere l’avviso; la scelta viene ricordata in modo tecnico sul
      dispositivo.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>4. Titolare e contatti</h2>
    <p>
      Confraternita di Misericordia di Borgo San Lorenzo,
      Via Giotto, 34 — 50032 Borgo San Lorenzo (FI), P. IVA 01343220487.
    </p>
    <p>
      Contatti:
      <a href="mailto:home@misericordia.net">home&#64;misericordia.net</a>,
      PEC
      <a href="mailto:misericordiabsl@legalmail.it">misericordiabsl&#64;legalmail.it</a>,
      tel. <a href="tel:0558494118">055 8494118</a>.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>5. Aggiornamenti</h2>
    <p>
      Questa Cookie Policy può essere aggiornata; la versione corrente è
      sempre disponibile su questa pagina.
    </p>
  </section>
</div>
